import {TrackItem, Powtoon} from 'powtoon-versioning/src/currentSchema'

const getPowtoonTracks = <T = TrackItem>(powtoon: Powtoon, filterFunction?: (tract: TrackItem) => boolean): T[] => (
  powtoon.slides.reduce<T[]>(
    (acc, slide) => [
      ...acc,
      ...(filterFunction ? slide.tracks.filter(filterFunction) : slide.tracks)
    ] as T[], []
  )
)


export default getPowtoonTracks